import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Modül seviyesinde kilit: React StrictMode bileşeni iki kez mount eder ve ref'ler
// sıfırlanır. session_id tek kullanımlık olduğundan ikinci istek 401 alıp kullanıcıyı
// yanlışlıkla /giris'e atardı. Kilidi session_id'ye bağlıyoruz ki aynı sekmede
// yapılan yeni bir giriş denemesi (farklı session_id) yine çalışabilsin.
let exchangedSessionId = null;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    if (!sessionId || exchangedSessionId === sessionId) return;
    exchangedSessionId = sessionId;
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("ata_token", data.token);
        setUser(data.user);
        navigate(data.user.role === "admin" || data.user.role === "super_admin" ? "/admin" : "/hesap", { replace: true, state: { user: data.user } });
      } catch {
        toast.error("Google ile giriş tamamlanamadı. Lütfen tekrar deneyin.");
        navigate("/giris", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-stone-500">
      <Loader2 className="w-8 h-8 animate-spin text-forest" />
      <p className="mt-4 text-sm">Google hesabınız doğrulanıyor...</p>
    </div>
  );
}
